import { MAX_REQUEST_PHOTO_BYTES, photoMessage, responseError } from './photoUpload';
export async function submitEcoBainToJotform({
  name,
  email,
  phone,
  street,
  city,
  province,
  postalCode,
  message,
  attribution,
  photoFiles,
  honeypot,
  language = "fr",
}) {
  if (honeypot && String(honeypot).trim() !== "") {
    return { ok: false, spam: true };
  }

  const fd = new FormData();

  // Champs texte (IDs Jotform)
  fd.append("q8_votreNom8", name || "");
  fd.append("q9_courriel9", email || "");
  fd.append("q10_votreNom10", phone || "");
  const attributionLines = attribution
    ? [
        "",
        "--- Attribution technique ---",
        `Source: ${attribution.source || "(direct)"}`,
        `Medium: ${attribution.medium || "(none)"}`,
        `Campaign: ${attribution.campaign || "(not set)"}`,
        `Landing page: ${attribution.landingPage || "/"}`,
        `Referrer: ${attribution.referrer || "(direct)"}`,
      ]
    : [];
  fd.append("q11_votreNom11", [message || "", ...attributionLines].join("\n").trim());

  // Adresse détaillée: Jotform attend des sous-champs, pas une string
  // (ton field est question 19: input_19_addr_line1 / city / state / postal)
  fd.append("q19_adresseDes[addr_line1]", street || "");
  fd.append("q19_adresseDes[city]", city || "");
  fd.append("q19_adresseDes[state]", province || ""); // optionnel ok
  fd.append("q19_adresseDes[postal]", postalCode || "");

  // Photos (question 13)
  if (photoFiles && photoFiles.length) {
    for (const file of Array.from(photoFiles)) {
      fd.append("q13_ajouterUne[]", file);
    }
  }

  // Check the complete multipart request, including text fields and boundaries.
  const requestBytes = (await new Response(fd).blob()).size;
  if (requestBytes > MAX_REQUEST_PHOTO_BYTES + 128 * 1024) {
    return { ok: false, error: photoMessage(language, 'total') };
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 60000);
  try {
    const r = await fetch('/api/jotform-eco-bain', {
      method: 'POST', body: fd, signal: controller.signal,
    });
    const data = await r.json().catch(() => null);
    return { ok: r.ok && data?.ok === true, status: data?.status || r.status,
      error: r.ok && data?.ok ? undefined : r.status >= 500 ? photoMessage(language, 'contactUnconfirmed') : responseError(r, null, language) };
  } catch (err) {
    return { ok: false, error: photoMessage(language, 'contactUnconfirmed') };
  } finally { clearTimeout(timer); }
}
